import { DPP_PROXY_BASE_PATH, DPP_REQUEST_TIMEOUT_MS } from '@/data/dpp/constants';
import type { DppEventBatch, DppEventBatchDocument, DppSendResult } from '@/data/dpp/types';

export const DPP_EVENTS_PATH = 'events';

export const buildDppEventBatchDocument = <Attributes = DppEventBatch>(
	batch: Attributes
): DppEventBatchDocument<Attributes> => ({
	data: { type: 'event-batches', attributes: batch },
});

const isPermanentRejection = (status: number) => status >= 400 && status < 500 && status !== 429;

export const sendDppEventBatch = async (
	batch: DppEventBatch,
	signal?: AbortSignal
): Promise<DppSendResult> => {
	const controller = new AbortController();
	const timer = setTimeout(() => controller.abort(), DPP_REQUEST_TIMEOUT_MS);
	const forward = () => controller.abort();
	signal?.addEventListener('abort', forward);

	try {
		const response = await fetch(`${DPP_PROXY_BASE_PATH}/${DPP_EVENTS_PATH}`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', accept: 'application/json' },
			body: JSON.stringify(buildDppEventBatchDocument(batch)),
			signal: controller.signal,
		});
		if (response.ok) {
			return 'accepted';
		}
		if (isPermanentRejection(response.status)) {
			return 'rejected';
		}
		throw new Error(`dpp events unavailable: ${response.status}`);
	} finally {
		clearTimeout(timer);
		signal?.removeEventListener('abort', forward);
	}
};
